export const ScrollTo = ({
  primary: { anchor: anchor },
}) => {
  return (
    <div data-scroll-to={anchor}></div>
  );
};
